export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = 'bt:accessToken';

export const getLocalStorage = (key: string): string | null => {
    const item = window.localStorage.getItem(key);
    return item ? item : null;
};

export const setLocalStorage = (key: string, value: string): void => {
    window.localStorage.setItem(key, value);
};

export const removeLocalStorage = (key: string): void => {
    window.localStorage.removeItem(key);
};
